<div class="plan-card">
  <div class="title-box">
    <div class="plan-title">
      <span class="title">{{ planCard.title }}</span>
      <span *ngIf="planCard.label" class="label">{{ planCard.label }}</span>
    </div>
    <div class="action">
      <ng-container
        *ngIf="planCard.details && planCard.details.selected; else actionButton"
      >
        <button type="button" class="btn" disabled>Current plan</button>
      </ng-container>
      <ng-template #actionButton>
        <button type="button" class="btn" (click)="emitActionChange()">
          {{ planCard.action }}
          <span
            aria-hidden="true"
            role="img"
            class="d-flex"
            *ngIf="
              planCard.action == properties.planCard.selectAction ||
              planCard.action == properties.planCard.SNAPAction
            "
          >
            <img
              alt="icon"
              aria-hidden="true"
              [src]="
                planCard.action === properties.planCard.selectAction
                  ? properties.planCard.plusIcon
                  : properties.planCard.moreIcon
              "
            />
          </span>
        </button>
      </ng-template>
    </div>
  </div>
  <div class="divider"></div>
  <div class="content">
    <span class="sr-only">{{planCard.bannerAnouncement}}</span>
    <span class="title" aria-hidden="true" [innerHTML]="planCard.banner"></span>
    <span class="sr-only">{{planCard.subBannerAnouncement}}</span>
    <span class="description" aria-hidden="true" [innerHTML]="planCard.subBanner"></span>
  </div>

  <ng-container *ngIf="planCard.benefits && planCard.benefits.length">
    <div class="divider"></div>
    <div class="benefits">
      <ng-container *ngFor="let item of planCard.benefits">
        <div
          class="description"
          [ngClass]="{ 'success-color': item.textColor === 'success' }"
        >
          <span aria-hidden="true" role="img">
            <img alt="icon" aria-hidden="true" src="{{ item.icon }}" />
          </span>
          {{ item.label }}
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
